// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"c895b9da","232":"c25729c5","237":"163fbee2","526":"bc4407f7"}[chunkId] + ".chunk.js";
};